import { Component, ElementRef, ViewChild } from "@angular/core";
import { BaseComponent } from "../../base.component";
import { AutoCompleteComponent } from "../components/auto-complete/auto-complete.component";
import { MultiSelectComponent } from "../components/multi-select/multi-select.component";
import { RangeSelectComponent } from "../components/range-select/range-select.component";

import * as _ from "lodash";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { Chart, ChartDataSets, ChartOptions } from "chart.js";
import { Color } from "ng2-charts";
import { VirtualScrollerComponent } from "ngx-virtual-scroller";
import { SessionManagerService } from "../../_services/SessionManager/session-manager.service";
import { customQueryFilters } from "./custom-query/custom-query-filters";
import { removeEmptyProperties } from "../../_helpers/remove-empy-properties";
import { ExcelOfApprovedCashFilter } from "./models/excel-of-approved-cash-filter";
import { ServerCustomCode } from "../../_models/serverCustomCode";
import { PaymentItemsSearchRequest } from "./models/payment-reuqest-structure";
import { ApplicationService } from "../../_services/application.service";
import { DataService } from "../../_services/data.service";
import { AlertService } from "../../_services/alert.service";
import { ChartService } from "../../_services/chart.service";
import { LoggerService } from "../../modules/logger/logger.service";
import { deepClone } from "../../_helpers/deepClone";

/*import { ScrollingModule } from '@angular/cdk/scrolling'
import { BrowserModule } from '@angular/platform-browser';*/

@Component({
  moduleId: module.id,
  selector: "payments",
  templateUrl: "payments.component.html",
  styleUrls: ["./payments.component.scss"],
})
export class PaymentsComponent extends BaseComponent {
  @ViewChild("layerSelect") public layerSelect: MultiSelectComponent;
  @ViewChild("paymentTypeSelect")
  public paymentTypeSelect: MultiSelectComponent;
  @ViewChild("nestSelect") public nestSelect: MultiSelectComponent;
  @ViewChild("childOrParentselect")
  public childOrParentSelect: AutoCompleteComponent;
  @ViewChild("eventSelect") public eventSelect: MultiSelectComponent;
  @ViewChild("childCountrySelect")
  public childCountrySelect: AutoCompleteComponent;
  @ViewChild("parentCountrySelect")
  public parentCountrySelect: AutoCompleteComponent;
  @ViewChild("receiptIssuersSelect")
  public receiptIssuersSelect: AutoCompleteComponent;
  @ViewChild("receiptNumberFilter")
  public receiptNumberFilter: AutoCompleteComponent;
  @ViewChild("paymentItemIdFormFilter")
  public paymentItemIdFormFilter?: ElementRef;
  @ViewChild("sumSelect") public sumSelect: RangeSelectComponent;
  @ViewChild("paymentDateSelect")
  public paymentDateSelect: RangeSelectComponent;
  @ViewChild("depositDate") public depositDate: RangeSelectComponent;
  @ViewChild("resultScroller") public resultScroller: any;
  @ViewChild("paymentStatusSelect") public paymentStatusSelect: any;
  @ViewChild("checkAllCheckbox") public checkAllCheckbox: any;

  @ViewChild(VirtualScrollerComponent)
  public virtualScroller: VirtualScrollerComponent;

  public filters: any;
  public paymentItems: any[];
  public selectedItems: any[] = [];
  public disableItemsSelect = false;
  public nestsWithCircles: any[];
  public initNestWithCircles: any[];
  public paymentStatusSelectValue: string = "null";
  public isCurrentYearSelected: boolean = true;
  public returnTypeValue: string;
  public layers: any[];
  public showAdvancedFilters: boolean = false;
  public pageIndex = 0;
  public pageSize = 200;
  public loading: boolean;
  public submitBtnLoading: boolean;
  public excelBtnLoading: boolean = false;
  public excelCashRefundBtnLoading: boolean = false;
  public totalResultsLength: number = 0;
  public lastFilter: any;
  public modalReference: any;
  public weeklyCountChartColors: Color[];
  public weeklyCountChartOptions: ChartOptions & { annotation: any };
  public weeklyCountChartLabels: any;
  public weeklyCountChartData: ChartDataSets[];
  public loadedWeeklyCount: boolean = false;
  public paymentSummeryChartColors: Color[];
  public paymentSummeryChartOptions: ChartOptions;
  public paymentSummeryChartLabels: any;
  public paymentSummeryChartData: any;
  public loadedPaymentSummery: boolean = false;

  public loadingUnhandledResults: boolean = false;
  public unhandledReturnsCount: number = 0;
  public unhandledItemsIds: any[] = [];
  public firstSeach: boolean = true;
  public checkAll: boolean = false;
  public collectiveRefundFeatureFlag: boolean;
  public ShowGetPaymentsSummaryFeature: boolean;
  public isGizbarMaagal = false;

  constructor(
    private applicationService: ApplicationService,
    public dataService: DataService,
    private alertService: AlertService,
    private modalService: NgbModal,
    public sessionManager: SessionManagerService,
    private chartService: ChartService,
    private logger: LoggerService
  ) {
    super(dataService, sessionManager);

    this.collectiveRefundFeatureFlag =
      this.sessionManager.features.collectiveRefund;
    this.ShowGetPaymentsSummaryFeature =
      this.sessionManager.features.ShowGetPaymentsSummary;

    // charts setup
    this.weeklyCountChartColors = [
      {
        backgroundColor: "rgba(0,0,0,0)",
        borderColor: "#00f",
        pointBackgroundColor: "rgba(148,159,177,1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(148,159,177,0.8)",
      },
    ];
    this.weeklyCountChartOptions = {
      responsive: true,
      scales: {
        xAxes: [{}],
        yAxes: [
          {
            id: "y-axis-0",
            position: "left",
          },
        ],
      },
      animation: {
        duration: 0,
        onComplete() {
          const chartInstance = this.chart;
          const ctx = chartInstance.ctx;

          ctx.font = Chart.helpers.fontString(
            Chart.defaults.global.defaultFontSize,
            Chart.defaults.global.defaultFontStyle,
            Chart.defaults.global.defaultFontFamily
          );
          ctx.textAlign = "center";
          ctx.textBaseline = "bottom";

          this.data.datasets.forEach((dataset, i) => {
            const meta = chartInstance.controller.getDatasetMeta(i);
            if (meta.data.length < 30) {
              meta.data.forEach((bar, index) => {
                const data = dataset.data[index];
                ctx.fillText(data, bar._model.x, bar._model.y - 8);
              });
            }
          });
        },
      },
    };

    this.paymentSummeryChartOptions =
      this.chartService.getPaymentSummaryChartConfig().paymentSummeryChartOptions;
    this.paymentSummeryChartColors =
      this.chartService.getPaymentSummaryChartConfig().paymentSummeryChartColors;
  }

  public run() {
    const user = this.base.user;
    this.isGizbarMaagal =
      this.sessionManager.getUserPermissions(user).gizbarMaagalOrUp;

    this.dataService.getPaymentFilters().subscribe((data) => {
      this.filters = data;
      this.nestsWithCircles = [
        ...data.nestsWithCircles.circles,
        ...data.nestsWithCircles.counties,
        ...data.nestsWithCircles.nests,
      ];
      if (
        user.circles.filter((circle) => circle.name === "ALL").length === 0 &&
        user.counties.filter((county) => county.name === "ALL").length === 0
      ) {
        if (user.nests.filter((nest) => nest.name === "ALL").length > 0) {
          this.initNestWithCircles = data.nestsWithCircles.counties.filter(
            (county) => {
              return (
                user.counties.filter(
                  (user_county) => user_county.countyId === county.id
                ).length === 1
              );
            }
          );
        } else {
          this.initNestWithCircles = data.nestsWithCircles.nests.filter(
            (nest) => {
              return (
                user.nests.filter((user_nest) => user_nest.nestId === nest.id)
                  .length === 1
              );
            }
          );
        }
      }
    });

    this.layers = [];
    this.base.user.layers.forEach((layer) => {
      this.layers.push({ id: layer.layerId, name: layer.layerName });
    });

    this.applicationService.counterBtnClicked.subscribe((counterBtnClicked) => {
      if (counterBtnClicked) {
        this.counterBtnClicked();
        this.applicationService.nextCounterBtnClicked(false);
      }
    });

    this.initCounter();
  }

  public initCounter() {
    this.dataService
      .postEntity("unhandled-returns", { countOnly: true, filter: {} })
      .subscribe(
        (resp) => {
          this.applicationService.nextcounterBtnCount(resp.totalResultsLength);
          this.unhandledReturnsCount = resp.totalResultsLength;
          this.unhandledItemsIds = resp.paymentItems
            ? resp.paymentItems.map((i) => i.id)
            : resp.itemsIds;
        },
        (error) => {
          this.logger.error(error);
        }
      );
  }

  public onReload() {
    this.initCounter();
    this.getPaymentItems({ firstPage: true });
  }

  public onResultScroll() {
    if (
      this.totalResultsLength === 0 ||
      this.totalResultsLength > this.paymentItems.length
    ) {
      const scrollFromTop =
        this.resultScroller.nativeElement.scrollTop +
        this.resultScroller.nativeElement.offsetHeight;
      const resultsDivContentHeight =
        this.resultScroller.nativeElement.scrollHeight;
      if (
        scrollFromTop >= resultsDivContentHeight * 0.6 &&
        !this.loading &&
        this.paymentItems.length > 0
      ) {
        this.pageIndex++;
        this.getPaymentItems({ firstPage: false });
      }
    }
  }

  public getWindowOffset(element) {
    let yPosition = 0;
    while (element) {
      yPosition += element.offsetTop - element.scrollTop + element.clientTop;
      element = element.offsetParent;
    }

    return yPosition;
  }

  public itemSelected(selected, item) {
    if (selected) {
      this.selectedItems.push(item.id);
      if (this.selectedItems.length === 20) {
        this.disableItemsSelect = true;
        this.alertService.warning(
          this.base.messages.collective_refund_warning_select_20_payments
        );
      }
    } else {
      this.selectedItems = this.selectedItems.filter((i) => i !== item.id);
      this.disableItemsSelect = false;
    }
    this.checkAll = this.selectedItems.length === this.paymentItems.length;
  }

  public selectAll() {
    // deselect all
    if (this.checkAll) {
      this.selectedItems = [];
      this.paymentItems.forEach((item) => {
        item.itemDetails.isChecked = false;
      });
      this.checkAll = false;
    } else {
      // select all
      this.paymentItems.slice(0, 20).forEach((item) => {
        item.itemDetails.isChecked = true;
        this.selectedItems.push(item["id"]);
      });
      if (this.paymentItems.length > 20) {
        this.alertService.error(
          this.base.messages.collective_refund_error_more_then_20_payment
        );
      }
      this.checkAll = true;
    }
  }

  public getPaymentItems(options) {
    const firstPage = !!options.firstPage;
    const paymentResultsUnlimited = !!options.paymentResultsUnlimited;
    const input_payment_item_id = this.paymentItemIdFormFilter
      ? this.paymentItemIdFormFilter.nativeElement.value.match(/[1-9].*/gm)
      : undefined;
    const payment_item_id = input_payment_item_id
      ? input_payment_item_id
      : undefined;
    if (firstPage) {
      this.pageIndex = 0;
    }
    const filter = _.merge(
      {
        paymentStatus:
          this.paymentStatusSelectValue !== "null"
            ? [this.paymentStatusSelectValue]
            : undefined,
      },
      this.layerSelect.submit(),
      this.paymentTypeSelect.submit(),
      this.nestSelect.submit(),

      this.childOrParentSelect.submit(),
      this.eventSelect.submit(),
      this.childCountrySelect.submit(),
      this.parentCountrySelect.submit(),
      { isCurrentYearSelected: this.isCurrentYearSelected },
      this.receiptIssuersSelect ? this.receiptIssuersSelect.submit() : {},
      this.receiptNumberFilter.submit(), // this.authNumberFormFilter.submit(),
      { items: payment_item_id },
      this.sumSelect.submit(),
      this.paymentDateSelect.submit(),
      this.depositDate ? this.depositDate.submit() : {},
      { returnTypeValue: this.returnTypeValue },
      { pageIndex: this.pageIndex },
      { pageSize: this.pageSize },
      { countResults: firstPage === true },
      { unhandledReturns: this.loadingUnhandledResults }
    );
    // filter = {childAndParent: {id: 3728, isParent: 0}, isCurrentYearSelected: false};
    this.lastFilter = filter;

    this.firstSeach = false;
    this.loadedWeeklyCount = false;
    this.loadedPaymentSummery = false;
    this.selectedItems = [];
    this.checkAll = false;
    this.loading = true;
    if (firstPage) {
      this.submitBtnLoading = true;
      this.paymentItems = [];
      if (!this.loadingUnhandledResults) {
        this.totalResultsLength = 0;
      }
    } else if (paymentResultsUnlimited) {
      this.submitBtnLoading = true;
    }
    const url = this.loadingUnhandledResults
      ? "unhandled-returns"
      : "payments/search";
    let postDataObject: any | PaymentItemsSearchRequest = {
      filter,
      countOnly: this.loadingUnhandledResults ? false : undefined,
      paymentResultsUnlimited,
    };
    if (url === "payments/search") {
      const paymentItemsSearchRequest: PaymentItemsSearchRequest =
        customQueryFilters.PaymentItemsSearchRequest(filter);
      postDataObject = removeEmptyProperties(paymentItemsSearchRequest);
      postDataObject.filters = removeEmptyProperties(
        postDataObject.filters
      ) as any;
    }

    this.dataService.postEntity(url, postDataObject).subscribe(
      (data) => {
        if (data) {
          if (data.totalResultsLength) {
            this.totalResultsLength = data.totalResultsLength;
          }

          // tslint:disable-next-line:prefer-conditional-expression
          if (firstPage || paymentResultsUnlimited) {
            this.paymentItems = data.paymentItems;
          } else {
            this.paymentItems = this.paymentItems.concat(data.paymentItems);
          }
          this.paymentItems.forEach((item) => {
            item.isCollapsed =
              item.isCollapsed !== undefined ? item.isCollapsed : true;
            item.itemDetails =
              item.itemDetails !== undefined ? item.itemDetails : {};
            if (this.checkAll) {
              item.itemDetails.isChecked = true;
            }
          });
          this.loading = false;
          this.submitBtnLoading = false;
        }
      },
      (error) => {
        const body = error.json && error.json();
        const msg =
          body && body.statusText
            ? this.base.messages[body.statusText]
              ? this.base.messages[body.statusText]
              : decodeURIComponent(body.statusText)
            : (error && error.statusText) || "error";
        this.loading = false;
        this.submitBtnLoading = false;
        if (msg === "error") {
          location.reload();
        } else {
          this.alertService.error(msg);
        }
      }
    );
  }

  public getCashRefundsExcel() {
    this.excelCashRefundBtnLoading = true;

    const customFilterObject = customQueryFilters.ExcelOfApprovedCash(
      this.lastFilter
    );

    const customFilterObjectWithoutEmptyProps: Partial<ExcelOfApprovedCashFilter> =
      removeEmptyProperties(customFilterObject);
    customFilterObjectWithoutEmptyProps.filters = removeEmptyProperties(
      customFilterObjectWithoutEmptyProps.filters
    ) as any;

    this.dataService
      .getExcel("paymentReturns/getExcelOfApprovedCash", {
        ...customFilterObjectWithoutEmptyProps,
      })
      .subscribe(
        (customServerCode) => {
          if (customServerCode === ServerCustomCode.NoResultForExcelFound) {
            this.alertService.info(
              this.base.messages.excel_download_no_cash_results_found
            );
          }
        },
        (error) => {
          this.alertService.error(this.base.messages.excel_download_error);
          this.excelCashRefundBtnLoading = false;
        },
        () => {
          this.excelCashRefundBtnLoading = false;
        }
      );
  }

  public getPaymentExcel() {
    this.excelBtnLoading = true;
    this.dataService
      .getExcel("payment-excel", { filter: this.lastFilter })
      .subscribe(
        (data) => {},
        (error) => {
          this.alertService.error(this.base.messages.excel_download_error);
          this.excelBtnLoading = false;
        },
        () => {
          this.excelBtnLoading = false;
        }
      );
  }

  public getPaymentsByWeek(content) {
    this.open(content);
    if (!this.loadedWeeklyCount) {
      this.weeklyCountChartLabels = [];
      this.weeklyCountChartData = [
        { data: [], label: this.base.messages.count },
      ];
      this.dataService
        .postEntity("payment-results-by-week", this.lastFilter)
        .subscribe(
          (resp) => {
            const lineChartLabels = [];
            const lineChartData = [];
            resp.weeklyCount.forEach((week) => {
              lineChartLabels.push(week.date);
              lineChartData.push(week.count);
            });
            this.weeklyCountChartLabels = lineChartLabels;
            this.weeklyCountChartData = [
              {
                data: lineChartData,
                label: this.base.messages.count,
              },
            ];
            this.loadedWeeklyCount = true;
          },
          (error) => {
            const body = error.json && error.json();
            this.alertService.error(
              body && body.statusText
                ? this.base.messages[body.statusText]
                  ? this.base.messages[body.statusText]
                  : decodeURIComponent(body.statusText)
                : (error && error.statusText) || error
            );
          }
        );
    }
  }

  public getPaymentSummery(content) {
    this.open(content, "create-event-window-class");
    if (!this.loadedPaymentSummery) {
      this.paymentSummeryChartLabels = [];
      this.paymentSummeryChartData = [];
      const clonedFilter = deepClone(this.lastFilter);
      clonedFilter.pageSize = 10000;
      this.dataService.postEntity("payment-summery", clonedFilter).subscribe(
        (resp) => {
          this.paymentSummeryChartData = [
            resp.results.income,
            resp.results.commitments,
            resp.results.openRecipes,
            resp.results.openRefunds,
            resp.results.refunded,
          ];
          this.paymentSummeryChartLabels = [];
          this.paymentSummeryChartLabels.push("שולם");
          this.paymentSummeryChartLabels.push("התחייבות");
          this.paymentSummeryChartLabels.push("קבלות פתוחות");
          this.paymentSummeryChartLabels.push("בקשות החזר בטיפול");
          this.paymentSummeryChartLabels.push("בקשות החזר שאושרו");
          this.loadedPaymentSummery = true;
        },
        (error) => {
          const body = error.json && error.json();
          this.alertService.error(
            body && body.statusText
              ? this.base.messages[body.statusText]
                ? this.base.messages[body.statusText]
                : decodeURIComponent(body.statusText)
              : (error && error.statusText) || error
          );
        }
      );
    }
  }

  public open(content: any, customClass?: string) {
    const windowClass = customClass || "modal-opened";
    const options: NgbModalOptions = {
      windowClass,
      backdrop: "static",
    };
    this.modalReference = this.modalService.open(content, options);
  }

  public selectPaymentStatus(event) {
    this.paymentStatusSelectValue =
      event.target.value !== "null" ? event.target.value : null;
  }

  public selectReturnType(event) {
    this.returnTypeValue =
      event.target.value !== "null" ? event.target.value : null;
  }

  public counterBtnClicked() {
    if (!this.loadingUnhandledResults) {
      this.pageIndex = 0;
      this.loadingUnhandledResults = true;
      this.getPaymentItems({ firstPage: true });
      this.totalResultsLength = this.unhandledReturnsCount;
    }
  }

  public $$devTryToGetManyItems() {
    const dataObject = {
      pageIndex: 0,
      pageSize: 20000,
      filters: {
        isCurrentYearSelected: true,
        sumForm: {},
        dateForm: {
          selectedOption: "PAYMENT",
        },
        depositClosedDateForm: {
          selectedOption: "DEPOSIT",
        },
      },
    };
    const url = "payments/search";
    this.loadingUnhandledResults = false;
    this.dataService.postEntity(url, dataObject).subscribe(
      (data) => {
        if (data) {
          if (data.totalResultsLength) {
            this.totalResultsLength = data.totalResultsLength;
          }

          this.loading = false;
          this.submitBtnLoading = false;
        }
      },
      (error) => {
        const body = error.json && error.json();
        const msg =
          body && body.statusText
            ? this.base.messages[body.statusText]
              ? this.base.messages[body.statusText]
              : decodeURIComponent(body.statusText)
            : (error && error.statusText) || "error";
        this.loading = false;
        this.submitBtnLoading = false;
        if (msg === "error") {
          location.reload();
        } else {
          this.alertService.error(msg);
        }
      }
    );
  }

  public submitForm() {
    this.loadingUnhandledResults = false;
    this.getPaymentItems({ firstPage: true });
  }

  public ngOnInit() {
    super.ngOnInit();
  }

  public ngOnDestroy() {
    super.ngOnDestroy();
    this.applicationService.nextcounterBtnCount(0);
  }

  private buildFilter({ firstPage, payment_item_id }) {
    const filter = _.merge(
      {
        paymentStatus:
          this.paymentStatusSelectValue !== "null"
            ? [this.paymentStatusSelectValue]
            : undefined,
      },
      this.layerSelect.submit(),
      this.paymentTypeSelect.submit(),
      this.nestSelect.submit(),
      this.childOrParentSelect.submit(),
      this.eventSelect.submit(),
      this.childCountrySelect.submit(),
      this.parentCountrySelect.submit(),
      { isCurrentYearSelected: this.isCurrentYearSelected },
      this.receiptIssuersSelect ? this.receiptIssuersSelect.submit() : {},
      this.receiptNumberFilter.submit(), // this.authNumberFormFilter.submit(),
      { items: payment_item_id },
      this.sumSelect.submit(),
      this.paymentDateSelect.submit(),
      this.depositDate ? this.depositDate.submit() : {},
      { returnTypeValue: this.returnTypeValue },
      { pageIndex: this.pageIndex },
      { pageSize: this.pageSize },
      { countResults: firstPage === true },
      { unhandledReturns: this.loadingUnhandledResults }
    );
    return filter;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/payments/payments.component.ts